import { Component, OnInit } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-youth-baseball-page',
  templateUrl: './youth-baseball-page.component.html',
  styleUrls: ['./youth-baseball-page.component.scss'],
})
export class YouthBaseballPageComponent implements OnInit {
  screenType = ScreenType;
  constructor() {}

  ngOnInit(): void {}
}
